import { Component } from '@angular/core';

import { MeetingListComponent } from '@galaxy/meeting-analysis';

@Component({
  selector: 'meeting-scheduler-my-recordings',
  template: `<meeting-analysis-meeting-list></meeting-analysis-meeting-list>`,
  styleUrls: ['./my-recordings.component.scss'],
  imports: [MeetingListComponent],
})
export class MyRecordingsComponent {}
